import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";

//import { axiosInstancePayment, axiosInstancePaymentIframe } from "../../../../axios.js";
import { GET_LEGACY_REGISTRATION_COUNT } from "../../../../Urls";
import { CommonDefaultPassword } from "../../../../features/constants/commonEnum";

const initialState = {
  countData: { data: {}, loading: false },
  userSearchInfo: {
    email: "",
    email_search_field: "",
    firstName: "",
    lastName: "",
    mobile: "",
    mobile_search_field: "",
    password: CommonDefaultPassword,
    account_number: "",
    service_address_line1: "",
    service_address_line2: "",
    service_address_city: "",
    service_address_state: "",
    service_address_postal_code: "",
    confirm_password: CommonDefaultPassword,
    paymentMethod: "CC",
  },
  accountField: {
    email: "",
    firstName: "",
    lastName: "",
    mobile: "",
    password: CommonDefaultPassword,
    fiber_account: false,
    fiber_account_number: "",
    gas_account: false,
    gas_account_number: "",
    service_address_line1: "",
    service_address_line2: "",
    service_address_city: "",
    service_address_state: "",
    service_address_postal_code: "",
    confirm_password: CommonDefaultPassword,
    paymentMethod: "CC",
  },
  paymentIframAccount: { data: {}, loading: false },
  paymentIframDetails: { data: {}, loading: false },
  activeServices: { data: [], loading: false },
  paymentProfiles: { data: [], loading: false },
  submitPaymentResponseData: { data: false, loading: false },
  createAccountData: { data: {}, loading: false }
};

export const getLegacyRegistrationCount = createAsyncThunk(
  "app/get/legacySlice/registrationCount",
  async (payload) => {
    const response = await axios.get(GET_LEGACY_REGISTRATION_COUNT);
    return response;
  }
);

export const getPayemntGateWay = createAsyncThunk(
  "app/get/legacySlice/getPayementGateWay",
  async (payload) => {
    const response = await axios.get(
      `/api/v1/legacy/payment-iframe-link?migration_account_parent_id=${payload.migration_account_parent_id}&postback_url=${payload.postback_url}&payment_category=${payload.payment_category}`
    );
    return response;
  }
);

export const getPayemntGateWayAcc = createAsyncThunk(
  "app/get/legacySlice/getPayemntGateWayAcc",
  async (payload) => {
    const response = await axios.get(
      `/api/v1/legacy/payment-iframe-link?email=${payload.email}&postback_url=${payload.postback_url}&payment_category=${payload.payment_category}`
    );
    return response;
  }
);

export const getPayemntProfiles = createAsyncThunk(
  "app/get/payement/getPayemntProfiles",
  async (payload) => {
    const response = await axios.get(
      `/api/v1/legacy/payment-profiles/${payload.migration_account_parent_id}`
    );
    return response;
  }
);

export const sendOtp = createAsyncThunk(
  "app/get/legacySlice/sendOtp",
  async (payload) => {
    const response = await axios.post(
      `/api/v1/legacy/send-otp`,
      payload
    );
    return response;
  }
);
export const validateOtp = createAsyncThunk(
  "app/get/legacySlice/validateOtp",
  async (payload) => {
    const response = await axios.post(
      `/api/v1/legacy/validate-otp`,
      payload
    );
    return response;
  }
);
export const getActiveServices = createAsyncThunk(
  "app/get/legacySlice/getActiveService",
  async (payload) => {
    const response = await axios.post(
      `/api/v1/legacy/get-active-services`,
      payload
    );
    return response;
  }
);

export const submitPaymentResponse = createAsyncThunk(
  "app/get/legacySlice/submitPaymentResponse",
  async (payload) => {
    const response = await axios.post(
      `/api/v1/legacy/submit-payment-response`,
      payload
    );
    return response;
  }
);

export const createAccount = createAsyncThunk(
  "app/get/legacySlice/createAccount",
  async (payload) => {
    const response = await axios.post(
      `/api/v1/legacy/create-account`,
      payload
    );
    return response;
  }
);

export const generateLegacyPMReport = createAsyncThunk(
  "app/get/legacySlice/generateLegacyPMReport",
  async (payload) => {
    const response = await axios.get(`/api/v1/legacy/generate-report?includeRegistered=${payload.includeRegistered}`, {
      responseType: "blob"
    });
    return response;
  }
);

export const generateLegacyPMReportData = createAsyncThunk(
  "app/get/legacySlice/generateLegacyPMReportData",
  async (payload) => {
    const response = await axios.get(`/api/v1/legacy/generate-report-data?includeRegistered=${payload.includeRegistered}`);
    return response;
  }
);

export const accountExistByEmail = createAsyncThunk(
  "app/get/payement/accountExistByEmail",
  async (payload) => {
    const response = await axios.get(
      `/api/v1/customer/account-exist-by-email/${payload.email}`,
      payload
    );
    return response;
  }
);

export const legacySlice = createSlice({
  name: "legacySlice/admin",
  initialState,
  reducers: {
    resetAllData: (state, action) => {
      state.userSearchInfo = {
        email: "",
        email_search_field: "",
        firstName: "",
        lastName: "",
        mobile: "",
        mobile_search_field: "",
        password: CommonDefaultPassword,
        account_number: "",
        service_address_line1: "",
        service_address_line2: "",
        service_address_city: "",
        service_address_state: "",
        service_address_postal_code: "",
        confirm_password: CommonDefaultPassword,
        paymentMethod: "CC",
      };
      state.accountField = {
        email: "",
        firstName: "",
        lastName: "",
        mobile: "",
        password: CommonDefaultPassword,
        fiber_account: false,
        fiber_account_number: "",
        gas_account: false,
        gas_account_number: "",
        service_address_line1: "",
        service_address_line2: "",
        service_address_city: "",
        service_address_state: "",
        service_address_postal_code: "",
        confirm_password: CommonDefaultPassword,
        paymentMethod: "CC",
      }
      state.paymentIframDetails = { data: "", loading: false };
      state.paymentIframAccount = { data: {}, loading: false };
      state.activeServices = { data: [], loading: false };
      state.submitPaymentResponseData = { data: false, loading: false };
      state.paymentProfiles = { data: [], loading: false }
      state.createAccountData = { data: {}, loading: false };
    },
    resetPaymentData: (state, action) => {
      state.paymentIframDetails = { data: {}, loading: false };
      state.paymentIframAccount = { data: {}, loading: false };
      state.submitPaymentResponseData = { data: false, loading: false };
    },
    setSelectedService: (state, action) => {
      state.activeServices.data = action.payload;
    },
    updatedPaymentInfo: (state, action) => {
      const { event, feild } = action?.payload;
      let curentVlaues = { ...state.userSearchInfo };
      curentVlaues[feild] = event;

      state.userSearchInfo = { ...curentVlaues };
    },
    updatedPMAccountInfo: (state, action) => {
      const { event, feild } = action?.payload;
      let curentVlaues = { ...state.accountField };
      curentVlaues[feild] = event;

      state.accountField = { ...curentVlaues };
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getLegacyRegistrationCount.pending, (state) => {
        state.countData.loading = true;
      })
      .addCase(getLegacyRegistrationCount.fulfilled, (state, action) => {
        state.countData.loading = false;
        state.countData.data = action?.payload?.data?.data;
      })
      .addCase(getLegacyRegistrationCount.rejected, (state) => {
        state.countData.loading = false;
        state.countData.data = [];
      })
      .addCase(getPayemntGateWay.pending, (state) => {
        state.paymentIframDetails.loading = true;
      })
      .addCase(getPayemntGateWay.fulfilled, (state, action) => {
        state.paymentIframDetails.loading = false;
        state.paymentIframDetails.data = action?.payload?.data?.data;
      })
      .addCase(getPayemntGateWay.rejected, (state) => {
        state.paymentIframDetails.loading = false;
        state.paymentIframDetails.data = {};
      })
      .addCase(getPayemntGateWayAcc.pending, (state) => {
        state.paymentIframDetails.loading = true;
      })
      .addCase(getPayemntGateWayAcc.fulfilled, (state, action) => {
        state.paymentIframAccount.loading = false;
        state.paymentIframAccount.data = action?.payload?.data?.data;
      })
      .addCase(getPayemntGateWayAcc.rejected, (state) => {
        state.paymentIframAccount.loading = false;
        state.paymentIframAccount.data = {};
      })
      .addCase(getPayemntProfiles.pending, (state) => {
        state.paymentIframAccount.loading = true;
      })
      .addCase(getPayemntProfiles.fulfilled, (state, action) => {
        state.paymentProfiles.loading = false;
        state.paymentProfiles.data = action?.payload?.data?.data;
      })
      .addCase(getPayemntProfiles.rejected, (state) => {
        state.paymentProfiles.loading = false;
        state.paymentProfiles.data = [];
      })
      .addCase(getActiveServices.pending, (state) => {
        state.activeServices.loading = true;
      })
      .addCase(getActiveServices.fulfilled, (state, action) => {
        state.activeServices.loading = false;
        state.activeServices.data = action?.payload?.data?.data;
      })
      .addCase(getActiveServices.rejected, (state) => {
        state.activeServices.loading = false;
      })
      .addCase(submitPaymentResponse.pending, (state) => {
        state.submitPaymentResponseData.loading = true;
      })
      .addCase(submitPaymentResponse.fulfilled, (state, action) => {
        state.submitPaymentResponseData.loading = false;
        state.submitPaymentResponseData.data = action?.payload?.data?.data;
      })
      .addCase(submitPaymentResponse.rejected, (state) => {
        state.submitPaymentResponseData.loading = false;
      })
      .addCase(createAccount.pending, (state) => {
        state.createAccountData.loading = true;
      })
      .addCase(createAccount.fulfilled, (state, action) => {
        state.createAccountData.loading = false;
        state.createAccountData.data = action?.payload?.data?.data;
      })
      .addCase(createAccount.rejected, (state) => {
        state.createAccountData.loading = false;
      });
  },
});

export const { resetPaymentData, updatedPaymentInfo, setSelectedService, resetAllData, updatedPMAccountInfo } =
  legacySlice.actions;

export default legacySlice.reducer;
